import { ConnectComponent } from '../../_components/ConnectComponent'
import { PolicyholderDataView } from './PolicyholderData.view'
import { PolicyholderDataPresenter } from './PolicyholderData.presenter'

export const PolicyholderData = ConnectComponent(
  PolicyholderDataView,
  PolicyholderDataPresenter,
)
